import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const sendSms = (body) =>
  swRequest({
    path: "/api/sms/send",
    method: "POST",
    body,
  });
